export enum UserAddressesWidgetColumn {
  Address,
  Name,
  Deleted,
  Service,
  Actions,
}
